"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme = {
    config: {
        useSystemColorMode: false,
        initialColorMode: "light",
    },
    styles: {
        global: {
            html: {
                fontSize: { base: "10px", sm: "10px" },
                height: "100%",
            },
            body: {
                font: "400 12px/1.8 Open Sans, sans-serif",
                // fontFamily:
                //     "游ゴシック Medium,YuGothic,YuGothicM,Hiragino Kaku Gothic ProN,Hiragino Kaku Gothic Pro,メイリオ,Meiryo,sans-serif",
            },
        },
    },
    components: {
        Button: {
            baseStyle: {
                _focus: {
                    boxShadow: "none",
                },
            },
        },
        Link: {
            baseStyle: {
                _focus: {
                    boxShadow: "none",
                },
            },
        },
    },
};
exports.default = theme;
